import search from "assets/icons/search.png";
import back from "assets/icons/back.png";
import searchHighlight from "assets/icons/searchHighlight.png";
import iconFacebook from "assets/icons/facebook.png";
import iconKakaotalk from "assets/icons/kakaotalk.png";
import iconCopy from "assets/icons/copy.png";
import iconShare from "assets/icons/share.png";

const icons = {
   back,
   search,
   searchHighlight,
   iconFacebook,
   iconKakaotalk,
   iconCopy,
   iconShare,
};
export default icons;
